export const CARRIER_CACHE_PREFIX = "loadevo.carrier.edit.v1.";
export const CARRIER_CACHE_TTL_MS = 10 * 60 * 1000; // 10 min

export function readCarrierCache(carrierId) {
  try {
    const raw = sessionStorage.getItem(`${CARRIER_CACHE_PREFIX}${carrierId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.data) return null;

    const ts = Number(parsed.ts || 0);
    if (ts && Date.now() - ts > CARRIER_CACHE_TTL_MS) return null;

    return parsed.data;
  } catch {
    return null;
  }
}

export function writeCarrierCache(carrierId, data) {
  try {
    sessionStorage.setItem(
      `${CARRIER_CACHE_PREFIX}${carrierId}`,
      JSON.stringify({ ts: Date.now(), data })
    );
  } catch {
    // ignore
  }
}
